

$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  slidesToShow: 1,
  adaptiveHeight: true
});



$('.review-section .review-left-itam').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});



$('.world-of-metals-section .world-of-metals-itam-main').slick({
  dots:true,
  infinite: true,
  arrows:false, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});

$('.recommand-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(document).on("click",".qtybox .btnqty",function() {
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
});







